function filterChange(e) {
  var requiredFilter = e.target.value;
  var allRelatedFAQs = e.target.closest('.collapsibleContentContainer').querySelectorAll('.accordion');
  var i, thisFilter;
  for (i = 0; i < allRelatedFAQs.length; i++) {
    thisFilter = allRelatedFAQs[i].getAttribute("data-filter");
    thisFilterArray = thisFilter.split(" ");
    if((thisFilterArray.includes(requiredFilter)) || (requiredFilter == 'all')) {
      allRelatedFAQs[i].style.display = 'block';
    } else {
      allRelatedFAQs[i].style.display = 'none';
    }
  }
}

if(document.querySelectorAll('.faqFilter') !== null) {
  var filterSelects = document.querySelectorAll('.faqFilter'), i;
  for (i = 0; i < filterSelects.length; i++) {
    filterSelects[i].onchange = filterChange;
  }
}